import http from "@/settings/apiSettings";

class SAL_CalculDataService {
  /** Calcul salarii pentru luna/an. salveaza=false → doar preview, fără a suprascrie SAL_CalculeSalarii.
   *  full=true → răspunsul include `Randuri` (toți angajații, toate coloanele) pentru tab-ul Rezultate. */
  calculeaza(luna: number, anul: number, salveaza = false, full = false): Promise<any> {
    return http.clientResurseUmane.post("/Salarizare/Calculeaza", null, {
      params: { luna, anul, salveaza, full },
    });
  }

  /** Inputuri manuale (ex. Zile lucratoare in luna), pivotate pe angajat, pentru luna/anul dat. */
  getManualInputs(luna: number, anul: number): Promise<any> {
    return http.clientResurseUmane.get("/Salarizare/ManualInputs", {
      params: { luna, anul },
    });
  }

  /** Închidere de lună salarii (IREVERSIBIL). */
  inchideLuna(luna: number, anul: number, rectificativ = false): Promise<any> {
    return http.clientResurseUmane.post("/Pontaj/InchideLuna", null, {
      params: { luna, anul, rectificativ },
    });
  }

  /** Spune dacă luna e închisă pe salarii (pentru read-only în UI). */
  esteLunaInchisa(luna: number, anul: number): Promise<any> {
    return http.clientResurseUmane.get("/Pontaj/EsteLunaInchisa", {
      params: { luna, anul },
    });
  }

  /** Salveaza o valoare de input manual pentru un angajat/luna. inValue = null -> sterge valoarea. */
  saveManualInput(empId: string, luna: number, anul: number, inputCode: string, inValue: number | null): Promise<any> {
    return http.clientResurseUmane.post("/Salarizare/SaveManualInput", {
      EmpId: empId,
      Luna: luna,
      Anul: anul,
      InputCode: inputCode,
      InValue: inValue,
    });
  }
}

export default new SAL_CalculDataService();
